import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TicketBadgeComponent } from './ticket-badge.component';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { RoutedDialogWrapperModule } from 'shared/routed-dialog/routed-dialog.module';
import { CustomerPrivacyModule } from 'layout/customer-privacy/customer-privacy.module';

@NgModule({
    declarations: [TicketBadgeComponent],
    imports: [CommonModule, MatIconModule, RouterModule, RoutedDialogWrapperModule, CustomerPrivacyModule],
    exports: [TicketBadgeComponent],
})
export class TicketBadgeModule {}
